import DOMPurify from 'dompurify';

export const sanitizeHtml = (dirty: string): string =>
  DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: [
      'p', 'br', 'strong', 'em', 'u', 's', 'a', 'ul', 'ol', 'li',
      'h1', 'h2', 'h3', 'img', 'pre', 'code', 'blockquote', 'span', 'sub', 'sup',
    ],
    ALLOWED_ATTR: ['href', 'src', 'alt', 'target', 'rel', 'style', 'class'],
  });
